export let reventasRedux=(valor)=>{ return {type:"REVENTAS",payload:valor} };
export let estadoReventa=(valor)=>{ return {type:"REVENTAS_ESTADO",payload:valor} };
export let newReventa=(valor)=>{ return {type:"NEW_REVENTA",payload:valor} };